import { JobType } from "@/types/job";

const googleJobSchemaGenerator = (job: JobType) => {
  const isJobInOfficeOnly =
    job.work_preference_new?.length === 1 &&
    job.work_preference_new[0] === "Onsite";

  const isJobRemoteOnly =
    job.work_preference_new?.length === 1 &&
    job.work_preference_new[0] === "Remote";

  // const isJobHybrid =
  //   job.work_preference_new.length >= 1 &&
  //   job.work_preference_new.includes("Hybrid");

  const inOfficeLocationSchema = {
    jobLocation: job.location_new?.map((city) => ({
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        // postalCode: "94043",
        // streetAddress: "1600 Amphitheatre Pkwy",
        addressLocality: city.name,
        addressRegion: city.region_code,
        addressCountry: city.country_code,
      },
    })),
  };

  const remoteLocationSchema = {
    jobLocationType: "TELECOMMUTE",
    applicantLocationRequirements: {
      "@type": "Country",
      name: "INDIA",
    },
  };

  const hybridLocationSchema = {
    jobLocation: job.location_new?.map((city) => ({
      "@type": "Place",
      address: {
        "@type": "PostalAddress",
        addressLocality: city.name,
        addressRegion: city.region_code,
        addressCountry: city.country_code,
      },
    })),
    jobLocationType: "TELECOMMUTE",
    applicantLocationRequirements: {
      "@type": "Country",
      name: "INDIA",
    },
  };

  return {
    "@context": "https://schema.org/",
    "@type": "JobPosting",
    directApply: true,
    title: job.title,
    // specify job is 100% remote in descritption, if it is remote. reference: https://developers.google.com/search/docs/appearance/structured-data/job-posting
    description: `<p>${job.job_description}. ${
      job.work_preference_new?.length === 1 &&
      job.work_preference_new[0] === "Remote"
        ? "<br /> This job is 100% remote."
        : ""
    } </p>`,
    identifier: {
      "@type": "PropertyValue",
      name: job.company.name,
      value: job.company.id,
    },
    datePosted: job.created_ts,
    employmentType: "FULL_TIME",
    hiringOrganization: {
      "@type": "Organization",
      name: job.company.name,
      ...(job.company.website && {
        sameAs: job.company.website,
      }),
      ...(job.company.logo && {
        logo: job.company.logo,
      }),
    },
    ...((job.min_salary || job.max_salary) && {
      baseSalary: {
        "@type": "MonetaryAmount",
        currency: "INR",
        value: {
          "@type": "QuantitativeValue",
          ...(job.min_salary && {
            minValue: job.min_salary,
          }),
          ...(job.max_salary && {
            maxValue: job.max_salary,
          }),
          unitText: "YEAR",
        },
      },
    }),
    ...(job.min_exp && {
      experienceRequirements: {
        "@type": "OccupationalExperienceRequirements",
        monthsOfExperience: job.min_exp * 12,
      },
    }),

    // handle REMOTE/HYBRID/IN-OFFICE job type
    // here we consider
    // zelevate - google schema           city required?
    // only onsite - onsite               yes
    // only remote - remote               no
    // only hybrid - hybrid               yes
    // hybrid, onsite - hybrid            yes
    // hybrid, remote - hybrid            yes
    // onsite, remote - hybrid            yes
    // onsite, remote, hybrid - hybrid    yes

    ...(isJobInOfficeOnly
      ? inOfficeLocationSchema
      : isJobRemoteOnly
      ? remoteLocationSchema
      : hybridLocationSchema),
  };
};

export default googleJobSchemaGenerator;
